import { Component, Input } from '@angular/core';

@Component({
    selector: 'influencer-posts-placeholder',
    templateUrl: './influencer-posts-placeholder.component.html',
    styleUrls: ['./influencer-posts-placeholder.component.scss']
})
export class InfluencerPostsPlaceholderComponent {
    @Input() isFetchingData: boolean;
    @Input() hasNoData: boolean;

    public emptyItemList = Array.from(Array(20).keys());
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/influencer-posts/influencer-posts-placeholder/influencer-posts-placeholder.component.ts